import React, { useRef, useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

export const DescriptionBox = ({ t, description, lang }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);

  const handleShowLess = () => {
    if (expanded && contentRef.current) {
      const top = contentRef.current.getBoundingClientRect().top + window.scrollY - 140;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };
  
  useEffect(() => {
    const checkHeight = () => {
      if (contentRef.current) {
        const el = contentRef.current;
        requestAnimationFrame(() => {
          setShowReadMore(el.scrollHeight > 319);
        });
      }
    };

    checkHeight();
    window.addEventListener('resize', checkHeight);
    return () => window.removeEventListener('resize', checkHeight);
  }, [description, lang]);

  return (
    <Box>
      <Box
        sx={{
          position: 'relative',
          maxHeight: expanded ? 'none' : 319,
          overflow: expanded ? 'visible' : 'hidden',
          transition: 'max-height 0.3s',
        }}
      >
        <Box
          ref={contentRef}
          sx={{
            whiteSpace: 'pre-line',
            fontSize: 14,
            color: 'text.primary',
            display: 'block',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            width: '100%',
            maxWidth: '100%',
          }}
        >
          {description || t('no-information')}
        </Box>
        {!expanded && showReadMore && (
          <Box
            sx={{
              position: 'absolute',
              left: 0,
              right: 0,
              bottom: 0,
              height: 60,
              background: 'linear-gradient(180deg, rgba(255,255,255,0) 0%, #fff 80%)',
              pointerEvents: 'none',
            }}
          />
        )}
      </Box>

      {showReadMore && (
        <Box textAlign="center">
          <Button
            variant="text"
            size="small"
            onClick={() => {
              setExpanded((prev) => !prev)
              handleShowLess();
            }}
            endIcon={
              expanded ? (
                <RemoveCircleOutlineIcon sx={{ color: (theme) => theme.palette.primary.main }} />
              ) : (
                <ControlPointIcon sx={{ color: (theme) => theme.palette.primary.main }} />
              )
            }
            sx={{
              color: '#000',
              textTransform: 'none',
              '&:hover': {
                color: (theme) => theme.palette.primary.main,
                backgroundColor: 'transparent',
              },
            }}
          >
            {expanded ? t('read-less') : t('read-all')}
          </Button>
        </Box>
      )}
    </Box>
  );
};
